const z = Symbol.for("constructDateFrom");
function p(r, e) {
  return typeof r == "function" ? r(e) : r && typeof r == "object" && z in r ? r[z](e) : r instanceof Date ? new r.constructor(e) : new Date(e);
}
function g(r, e) {
  return p(e || r, r);
}
function ee(r, e, t) {
  const n = g(r, t?.in);
  return isNaN(e) ? p(t?.in || r, NaN) : (e && n.setDate(n.getDate() + e), n);
}
let he = {};
function q() {
  return he;
}
function O(r, e) {
  const t = q(), n = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, a = g(r, e?.in), s = a.getDay(), o = (s < n ? 7 : 0) + s - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function _(r, e) {
  return O(r, { ...e, weekStartsOn: 1 });
}
function te(r, e) {
  const t = g(r, e?.in), n = t.getFullYear(), a = p(t, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const s = _(a), o = p(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const c = _(o);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= c.getTime() ? n : n - 1;
}
function I(r) {
  const e = g(r), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +r - +t;
}
function me(r, ...e) {
  const t = p.bind(
    null,
    r || e.find((n) => typeof n == "object")
  );
  return e.map(t);
}
function J(r, e) {
  const t = g(r, e?.in);
  return t.setHours(0, 0, 0, 0), t;
}
function we(r, e, t) {
  const [n, a] = me(
    t?.in,
    r,
    e
  ), s = J(n), o = J(a), c = +s - I(s), P = +o - I(o);
  return Math.round((c - P) / 864e5);
}
function ye(r, e) {
  const t = te(r, e), n = p(r, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), _(n);
}
function be(r) {
  return r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function ge(r) {
  return !(!be(r) && typeof r != "number" || isNaN(+g(r)));
}
function pe(r, e) {
  const t = g(r, e?.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const xe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Pe = (r, e, t) => {
  let n;
  const a = xe[r];
  return typeof a == "string" ? n = a : e === 1 ? n = a.one : n = a.other.replace("{{count}}", e.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function L(r) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : r.defaultWidth;
    return r.formats[t] || r.formats[r.defaultWidth];
  };
}
const De = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Me = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ke = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Te = {
  date: L({
    formats: De,
    defaultWidth: "full"
  }),
  time: L({
    formats: Me,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: ke,
    defaultWidth: "full"
  })
}, Oe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ye = (r, e, t, n) => Oe[r];
function H(r) {
  return (e, t) => {
    const n = t?.context ? String(t.context) : "standalone";
    let a;
    if (n === "formatting" && r.formattingValues) {
      const o = r.defaultFormattingWidth || r.defaultWidth, c = t?.width ? String(t.width) : o;
      a = r.formattingValues[c] || r.formattingValues[o];
    } else {
      const o = r.defaultWidth, c = t?.width ? String(t.width) : r.defaultWidth;
      a = r.values[c] || r.values[o];
    }
    const s = r.argumentCallback ? r.argumentCallback(e) : e;
    return a[s];
  };
}
const ve = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ee = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, We = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, _e = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, qe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, He = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ne = (r, e) => {
  const t = Number(r), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Ie = {
  ordinalNumber: Ne,
  era: H({
    values: ve,
    defaultWidth: "wide"
  }),
  quarter: H({
    values: Ee,
    defaultWidth: "wide",
    argumentCallback: (r) => r - 1
  }),
  month: H({
    values: We,
    defaultWidth: "wide"
  }),
  day: H({
    values: _e,
    defaultWidth: "wide"
  }),
  dayPeriod: H({
    values: qe,
    defaultWidth: "wide",
    formattingValues: He,
    defaultFormattingWidth: "wide"
  })
};
function N(r) {
  return (e, t = {}) => {
    const n = t.width, a = n && r.matchPatterns[n] || r.matchPatterns[r.defaultMatchWidth], s = e.match(a);
    if (!s)
      return null;
    const o = s[0], c = n && r.parsePatterns[n] || r.parsePatterns[r.defaultParseWidth], P = Array.isArray(c) ? Ce(c, (b) => b.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Fe(c, (b) => b.test(o))
    );
    let x;
    x = r.valueCallback ? r.valueCallback(P) : P, x = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(x)
    ) : x;
    const m = e.slice(o.length);
    return { value: x, rest: m };
  };
}
function Fe(r, e) {
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t) && e(r[t]))
      return t;
}
function Ce(r, e) {
  for (let t = 0; t < r.length; t++)
    if (e(r[t]))
      return t;
}
function Le(r) {
  return (e, t = {}) => {
    const n = e.match(r.matchPattern);
    if (!n) return null;
    const a = n[0], s = e.match(r.parsePattern);
    if (!s) return null;
    let o = r.valueCallback ? r.valueCallback(s[0]) : s[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const c = e.slice(a.length);
    return { value: o, rest: c };
  };
}
const Qe = /^(\d+)(th|st|nd|rd)?/i, Re = /\d+/i, Xe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ge = {
  any: [/^b/i, /^(a|c)/i]
}, Be = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, je = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ve = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ze = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Je = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ze = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ke = {
  ordinalNumber: Le({
    matchPattern: Qe,
    parsePattern: Re,
    valueCallback: (r) => parseInt(r, 10)
  }),
  era: N({
    matchPatterns: Xe,
    defaultMatchWidth: "wide",
    parsePatterns: Ge,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: Be,
    defaultMatchWidth: "wide",
    parsePatterns: Ae,
    defaultParseWidth: "any",
    valueCallback: (r) => r + 1
  }),
  month: N({
    matchPatterns: je,
    defaultMatchWidth: "wide",
    parsePatterns: $e,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Ve,
    defaultMatchWidth: "wide",
    parsePatterns: ze,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: Je,
    defaultMatchWidth: "any",
    parsePatterns: Ze,
    defaultParseWidth: "any"
  })
}, ne = {
  code: "en-US",
  formatDistance: Pe,
  formatLong: Te,
  formatRelative: Ye,
  localize: Ie,
  match: Ke,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ue(r, e) {
  const t = g(r, e?.in);
  return we(t, pe(t)) + 1;
}
function re(r, e) {
  const t = g(r, e?.in), n = +_(t) - +ye(t);
  return Math.round(n / 6048e5) + 1;
}
function X(r, e) {
  const t = g(r, e?.in), n = t.getFullYear(), a = q(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, o = p(e?.in || r, 0);
  o.setFullYear(n + 1, 0, s), o.setHours(0, 0, 0, 0);
  const c = O(o, e), P = p(e?.in || r, 0);
  P.setFullYear(n, 0, s), P.setHours(0, 0, 0, 0);
  const x = O(P, e);
  return +t >= +c ? n + 1 : +t >= +x ? n : n - 1;
}
function Se(r, e) {
  const t = q(), n = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, a = X(r, e), s = p(e?.in || r, 0);
  return s.setFullYear(a, 0, n), s.setHours(0, 0, 0, 0), O(s, e);
}
function ae(r, e) {
  const t = g(r, e?.in), n = +O(t, e) - +Se(t, e);
  return Math.round(n / 6048e5) + 1;
}
function d(r, e) {
  const t = r < 0 ? "-" : "", n = Math.abs(r).toString().padStart(e, "0");
  return t + n;
}
const T = {
  // Year
  y(r, e) {
    const t = r.getFullYear(), n = t > 0 ? t : 1 - t;
    return d(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(r, e) {
    const t = r.getMonth();
    return e === "M" ? String(t + 1) : d(t + 1, 2);
  },
  // Day of the month
  d(r, e) {
    return d(r.getDate(), e.length);
  },
  // AM or PM
  a(r, e) {
    const t = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(r, e) {
    return d(r.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(r, e) {
    return d(r.getHours(), e.length);
  },
  // Minute
  m(r, e) {
    return d(r.getMinutes(), e.length);
  },
  // Second
  s(r, e) {
    return d(r.getSeconds(), e.length);
  },
  // Fraction of second
  S(r, e) {
    const t = e.length, n = r.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return d(a, e.length);
  }
}, W = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Z = {
  // Era
  G: function(r, e, t) {
    const n = r.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(r, e, t) {
    if (e === "yo") {
      const n = r.getFullYear(), a = n > 0 ? n : 1 - n;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return T.y(r, e);
  },
  // Local week-numbering year
  Y: function(r, e, t, n) {
    const a = X(r, n), s = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const o = s % 100;
      return d(o, 2);
    }
    return e === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : d(s, e.length);
  },
  // ISO week-numbering year
  R: function(r, e) {
    const t = te(r);
    return d(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, e) {
    const t = r.getFullYear();
    return d(t, e.length);
  },
  // Quarter
  Q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return d(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return d(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return T.M(r, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return d(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(r, e, t, n) {
    const a = ae(r, n);
    return e === "wo" ? t.ordinalNumber(a, { unit: "week" }) : d(a, e.length);
  },
  // ISO week of year
  I: function(r, e, t) {
    const n = re(r);
    return e === "Io" ? t.ordinalNumber(n, { unit: "week" }) : d(n, e.length);
  },
  // Day of the month
  d: function(r, e, t) {
    return e === "do" ? t.ordinalNumber(r.getDate(), { unit: "date" }) : T.d(r, e);
  },
  // Day of year
  D: function(r, e, t) {
    const n = Ue(r);
    return e === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : d(n, e.length);
  },
  // Day of week
  E: function(r, e, t) {
    const n = r.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, e, t, n) {
    const a = r.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return d(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, e, t, n) {
    const a = r.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return d(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, e, t) {
    const n = r.getDay(), a = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return d(a, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, e, t) {
    const a = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, e, t) {
    const n = r.getHours();
    let a;
    switch (n === 12 ? a = W.noon : n === 0 ? a = W.midnight : a = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, e, t) {
    const n = r.getHours();
    let a;
    switch (n >= 17 ? a = W.evening : n >= 12 ? a = W.afternoon : n >= 4 ? a = W.morning : a = W.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, e, t) {
    if (e === "ho") {
      let n = r.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return T.h(r, e);
  },
  // Hour [0-23]
  H: function(r, e, t) {
    return e === "Ho" ? t.ordinalNumber(r.getHours(), { unit: "hour" }) : T.H(r, e);
  },
  // Hour [0-11]
  K: function(r, e, t) {
    const n = r.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : d(n, e.length);
  },
  // Hour [1-24]
  k: function(r, e, t) {
    let n = r.getHours();
    return n === 0 && (n = 24), e === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : d(n, e.length);
  },
  // Minute
  m: function(r, e, t) {
    return e === "mo" ? t.ordinalNumber(r.getMinutes(), { unit: "minute" }) : T.m(r, e);
  },
  // Second
  s: function(r, e, t) {
    return e === "so" ? t.ordinalNumber(r.getSeconds(), { unit: "second" }) : T.s(r, e);
  },
  // Fraction of second
  S: function(r, e) {
    return T.S(r, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, e, t) {
    const n = r.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return U(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return v(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return v(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return U(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return v(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return v(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + K(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + v(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + K(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + v(n, ":");
    }
  },
  // Seconds timestamp
  t: function(r, e, t) {
    const n = Math.trunc(+r / 1e3);
    return d(n, e.length);
  },
  // Milliseconds timestamp
  T: function(r, e, t) {
    return d(+r, e.length);
  }
};
function K(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), a = Math.trunc(n / 60), s = n % 60;
  return s === 0 ? t + String(a) : t + String(a) + e + d(s, 2);
}
function U(r, e) {
  return r % 60 === 0 ? (r > 0 ? "-" : "+") + d(Math.abs(r) / 60, 2) : v(r, e);
}
function v(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), a = d(Math.trunc(n / 60), 2), s = d(n % 60, 2);
  return t + a + e + s;
}
const S = (r, e) => {
  switch (r) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, se = (r, e) => {
  switch (r) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, et = (r, e) => {
  const t = r.match(/(P+)(p+)?/) || [], n = t[1], a = t[2];
  if (!a)
    return S(r, e);
  let s;
  switch (n) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", S(n, e)).replace("{{time}}", se(a, e));
}, Q = {
  p: se,
  P: et
}, tt = /^D+$/, nt = /^Y+$/, rt = ["D", "DD", "YY", "YYYY"];
function oe(r) {
  return tt.test(r);
}
function ie(r) {
  return nt.test(r);
}
function R(r, e, t) {
  const n = at(r, e, t);
  if (console.warn(n), rt.includes(r)) throw new RangeError(n);
}
function at(r, e, t) {
  const n = r[0] === "Y" ? "years" : "days of the month";
  return `Use \`${r.toLowerCase()}\` instead of \`${r}\` (in \`${e}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const st = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, it = /^'([^]*?)'?$/, ut = /''/g, ct = /[a-zA-Z]/;
function cn(r, e, t) {
  const n = q(), a = t?.locale ?? n.locale ?? ne, s = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, c = g(r, t?.in);
  if (!ge(c))
    throw new RangeError("Invalid time value");
  let P = e.match(ot).map((m) => {
    const b = m[0];
    if (b === "p" || b === "P") {
      const Y = Q[b];
      return Y(m, a.formatLong);
    }
    return m;
  }).join("").match(st).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const b = m[0];
    if (b === "'")
      return { isToken: !1, value: dt(m) };
    if (Z[b])
      return { isToken: !0, value: m };
    if (b.match(ct))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: m };
  });
  a.localize.preprocessor && (P = a.localize.preprocessor(c, P));
  const x = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: a
  };
  return P.map((m) => {
    if (!m.isToken) return m.value;
    const b = m.value;
    (!t?.useAdditionalWeekYearTokens && ie(b) || !t?.useAdditionalDayOfYearTokens && oe(b)) && R(b, e, String(r));
    const Y = Z[b[0]];
    return Y(c, b, a.localize, x);
  }).join("");
}
function dt(r) {
  const e = r.match(it);
  return e ? e[1].replace(ut, "'") : r;
}
function lt() {
  return Object.assign({}, q());
}
function ft(r, e) {
  const t = g(r, e?.in).getDay();
  return t === 0 ? 7 : t;
}
function ht(r, e) {
  const t = mt(e) ? new e(0) : p(e, 0);
  return t.setFullYear(r.getFullYear(), r.getMonth(), r.getDate()), t.setHours(
    r.getHours(),
    r.getMinutes(),
    r.getSeconds(),
    r.getMilliseconds()
  ), t;
}
function mt(r) {
  return typeof r == "function" && r.prototype?.constructor === r;
}
const wt = 10;
class ue {
  subPriority = 0;
  validate(e, t) {
    return !0;
  }
}
class yt extends ue {
  constructor(e, t, n, a, s) {
    super(), this.value = e, this.validateValue = t, this.setValue = n, this.priority = a, s && (this.subPriority = s);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, n) {
    return this.setValue(e, t, this.value, n);
  }
}
class bt extends ue {
  priority = wt;
  subPriority = -1;
  constructor(e, t) {
    super(), this.context = e || ((n) => p(t, n));
  }
  set(e, t) {
    return t.timestampIsSet ? e : p(e, ht(e, this.context));
  }
}
class u {
  run(e, t, n, a) {
    const s = this.parse(e, t, n, a);
    return s ? {
      setter: new yt(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(e, t, n) {
    return !0;
  }
}
class gt extends u {
  priority = 140;
  parse(e, t, n) {
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
      // A, B
      case "GGGGG":
        return n.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(e, { width: "wide" }) || n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
    }
  }
  set(e, t, n) {
    return t.era = n, e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const w = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, M = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function y(r, e) {
  return r && {
    value: e(r.value),
    rest: r.rest
  };
}
function l(r, e) {
  const t = e.match(r);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function k(r, e) {
  const t = e.match(r);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, s = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (a * 36e5 + s * 6e4 + o * 1e3),
    rest: e.slice(t[0].length)
  };
}
function ce(r) {
  return l(w.anyDigitsSigned, r);
}
function h(r, e) {
  switch (r) {
    case 1:
      return l(w.singleDigit, e);
    case 2:
      return l(w.twoDigits, e);
    case 3:
      return l(w.threeDigits, e);
    case 4:
      return l(w.fourDigits, e);
    default:
      return l(new RegExp("^\\d{1," + r + "}"), e);
  }
}
function F(r, e) {
  switch (r) {
    case 1:
      return l(w.singleDigitSigned, e);
    case 2:
      return l(w.twoDigitsSigned, e);
    case 3:
      return l(w.threeDigitsSigned, e);
    case 4:
      return l(w.fourDigitsSigned, e);
    default:
      return l(new RegExp("^-?\\d{1," + r + "}"), e);
  }
}
function G(r) {
  switch (r) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function de(r, e) {
  const t = e > 0, n = t ? e : 1 - e;
  let a;
  if (n <= 50)
    a = r || 100;
  else {
    const s = n + 50, o = Math.trunc(s / 100) * 100, c = r >= s % 100;
    a = r + o - (c ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function le(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
class pt extends u {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(e, t, n) {
    const a = (s) => ({
      year: s,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return y(h(4, e), a);
      case "yo":
        return y(
          n.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return y(h(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, n) {
    const a = e.getFullYear();
    if (n.isTwoDigitYear) {
      const o = de(
        n.year,
        a
      );
      return e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const s = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
    return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class xt extends u {
  priority = 130;
  parse(e, t, n) {
    const a = (s) => ({
      year: s,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return y(h(4, e), a);
      case "Yo":
        return y(
          n.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return y(h(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, n, a) {
    const s = X(e, a);
    if (n.isTwoDigitYear) {
      const c = de(
        n.year,
        s
      );
      return e.setFullYear(
        c,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), O(e, a);
    }
    const o = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
    return e.setFullYear(o, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), O(e, a);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class Pt extends u {
  priority = 130;
  parse(e, t) {
    return F(t === "R" ? 4 : t.length, e);
  }
  set(e, t, n) {
    const a = p(e, 0);
    return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), _(a);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Dt extends u {
  priority = 130;
  parse(e, t) {
    return F(t === "u" ? 4 : t.length, e);
  }
  set(e, t, n) {
    return e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class Mt extends u {
  priority = 120;
  parse(e, t, n) {
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return h(t.length, e);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || n.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, n) {
    return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class kt extends u {
  priority = 120;
  parse(e, t, n) {
    switch (t) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return h(t.length, e);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || n.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, n) {
    return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Tt extends u {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(e, t, n) {
    const a = (s) => s - 1;
    switch (t) {
      // 1, 2, ..., 12
      case "M":
        return y(
          l(w.month, e),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return y(h(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return y(
          n.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(e, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return n.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(e, { width: "wide", context: "formatting" }) || n.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, n) {
    return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ot extends u {
  priority = 110;
  parse(e, t, n) {
    const a = (s) => s - 1;
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return y(
          l(w.month, e),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return y(h(2, e), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return y(
          n.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(e, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return n.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(e, { width: "wide", context: "standalone" }) || n.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, n) {
    return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function Yt(r, e, t) {
  const n = g(r, t?.in), a = ae(n, t) - e;
  return n.setDate(n.getDate() - a * 7), g(n, t?.in);
}
class vt extends u {
  priority = 100;
  parse(e, t, n) {
    switch (t) {
      case "w":
        return l(w.week, e);
      case "wo":
        return n.ordinalNumber(e, { unit: "week" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, n, a) {
    return O(Yt(e, n, a), a);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function Et(r, e, t) {
  const n = g(r, t?.in), a = re(n, t) - e;
  return n.setDate(n.getDate() - a * 7), n;
}
class Wt extends u {
  priority = 100;
  parse(e, t, n) {
    switch (t) {
      case "I":
        return l(w.week, e);
      case "Io":
        return n.ordinalNumber(e, { unit: "week" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, n) {
    return _(Et(e, n));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const _t = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], qt = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ht extends u {
  priority = 90;
  subPriority = 1;
  parse(e, t, n) {
    switch (t) {
      case "d":
        return l(w.date, e);
      case "do":
        return n.ordinalNumber(e, { unit: "date" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    const n = e.getFullYear(), a = le(n), s = e.getMonth();
    return a ? t >= 1 && t <= qt[s] : t >= 1 && t <= _t[s];
  }
  set(e, t, n) {
    return e.setDate(n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Nt extends u {
  priority = 90;
  subpriority = 1;
  parse(e, t, n) {
    switch (t) {
      case "D":
      case "DD":
        return l(w.dayOfYear, e);
      case "Do":
        return n.ordinalNumber(e, { unit: "date" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    const n = e.getFullYear();
    return le(n) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(e, t, n) {
    return e.setMonth(0, n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function B(r, e, t) {
  const n = q(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, s = g(r, t?.in), o = s.getDay(), P = (e % 7 + 7) % 7, x = 7 - a, m = e < 0 || e > 6 ? e - (o + x) % 7 : (P + x) % 7 - (o + x) % 7;
  return ee(s, m, t);
}
class It extends u {
  priority = 90;
  parse(e, t, n) {
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return n.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return n.day(e, { width: "wide", context: "formatting" }) || n.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, n, a) {
    return e = B(e, n, a), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class Ft extends u {
  priority = 90;
  parse(e, t, n, a) {
    const s = (o) => {
      const c = Math.floor((o - 1) / 7) * 7;
      return (o + a.weekStartsOn + 6) % 7 + c;
    };
    switch (t) {
      // 3
      case "e":
      case "ee":
        return y(h(t.length, e), s);
      // 3rd
      case "eo":
        return y(
          n.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      // Tue
      case "eee":
        return n.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return n.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return n.day(e, { width: "wide", context: "formatting" }) || n.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(e, { width: "short", context: "formatting" }) || n.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, n, a) {
    return e = B(e, n, a), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class Ct extends u {
  priority = 90;
  parse(e, t, n, a) {
    const s = (o) => {
      const c = Math.floor((o - 1) / 7) * 7;
      return (o + a.weekStartsOn + 6) % 7 + c;
    };
    switch (t) {
      // 3
      case "c":
      case "cc":
        return y(h(t.length, e), s);
      // 3rd
      case "co":
        return y(
          n.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      // Tue
      case "ccc":
        return n.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(e, { width: "short", context: "standalone" }) || n.day(e, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return n.day(e, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(e, { width: "short", context: "standalone" }) || n.day(e, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return n.day(e, { width: "wide", context: "standalone" }) || n.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(e, { width: "short", context: "standalone" }) || n.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, n, a) {
    return e = B(e, n, a), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function Lt(r, e, t) {
  const n = g(r, t?.in), a = ft(n, t), s = e - a;
  return ee(n, s, t);
}
class Qt extends u {
  priority = 90;
  parse(e, t, n) {
    const a = (s) => s === 0 ? 7 : s;
    switch (t) {
      // 2
      case "i":
      case "ii":
        return h(t.length, e);
      // 2nd
      case "io":
        return n.ordinalNumber(e, { unit: "day" });
      // Tue
      case "iii":
        return y(
          n.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(e, {
            width: "short",
            context: "formatting"
          }) || n.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return y(
          n.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return y(
          n.day(e, {
            width: "short",
            context: "formatting"
          }) || n.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return y(
          n.day(e, {
            width: "wide",
            context: "formatting"
          }) || n.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(e, {
            width: "short",
            context: "formatting"
          }) || n.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 7;
  }
  set(e, t, n) {
    return e = Lt(e, n), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Rt extends u {
  priority = 80;
  parse(e, t, n) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, n) {
    return e.setHours(G(n), 0, 0, 0), e;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class Xt extends u {
  priority = 80;
  parse(e, t, n) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, n) {
    return e.setHours(G(n), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class Gt extends u {
  priority = 80;
  parse(e, t, n) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, n) {
    return e.setHours(G(n), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class Bt extends u {
  priority = 70;
  parse(e, t, n) {
    switch (t) {
      case "h":
        return l(w.hour12h, e);
      case "ho":
        return n.ordinalNumber(e, { unit: "hour" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 12;
  }
  set(e, t, n) {
    const a = e.getHours() >= 12;
    return a && n < 12 ? e.setHours(n + 12, 0, 0, 0) : !a && n === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class At extends u {
  priority = 70;
  parse(e, t, n) {
    switch (t) {
      case "H":
        return l(w.hour23h, e);
      case "Ho":
        return n.ordinalNumber(e, { unit: "hour" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 23;
  }
  set(e, t, n) {
    return e.setHours(n, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class jt extends u {
  priority = 70;
  parse(e, t, n) {
    switch (t) {
      case "K":
        return l(w.hour11h, e);
      case "Ko":
        return n.ordinalNumber(e, { unit: "hour" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, n) {
    return e.getHours() >= 12 && n < 12 ? e.setHours(n + 12, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class $t extends u {
  priority = 70;
  parse(e, t, n) {
    switch (t) {
      case "k":
        return l(w.hour24h, e);
      case "ko":
        return n.ordinalNumber(e, { unit: "hour" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 24;
  }
  set(e, t, n) {
    const a = n <= 24 ? n % 24 : n;
    return e.setHours(a, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class Vt extends u {
  priority = 60;
  parse(e, t, n) {
    switch (t) {
      case "m":
        return l(w.minute, e);
      case "mo":
        return n.ordinalNumber(e, { unit: "minute" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, n) {
    return e.setMinutes(n, 0, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class zt extends u {
  priority = 50;
  parse(e, t, n) {
    switch (t) {
      case "s":
        return l(w.second, e);
      case "so":
        return n.ordinalNumber(e, { unit: "second" });
      default:
        return h(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, n) {
    return e.setSeconds(n, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class Jt extends u {
  priority = 30;
  parse(e, t) {
    const n = (a) => Math.trunc(a * Math.pow(10, -t.length + 3));
    return y(h(t.length, e), n);
  }
  set(e, t, n) {
    return e.setMilliseconds(n), e;
  }
  incompatibleTokens = ["t", "T"];
}
class Zt extends u {
  priority = 10;
  parse(e, t) {
    switch (t) {
      case "X":
        return k(
          M.basicOptionalMinutes,
          e
        );
      case "XX":
        return k(M.basic, e);
      case "XXXX":
        return k(
          M.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return k(
          M.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return k(M.extended, e);
    }
  }
  set(e, t, n) {
    return t.timestampIsSet ? e : p(
      e,
      e.getTime() - I(e) - n
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class Kt extends u {
  priority = 10;
  parse(e, t) {
    switch (t) {
      case "x":
        return k(
          M.basicOptionalMinutes,
          e
        );
      case "xx":
        return k(M.basic, e);
      case "xxxx":
        return k(
          M.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return k(
          M.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return k(M.extended, e);
    }
  }
  set(e, t, n) {
    return t.timestampIsSet ? e : p(
      e,
      e.getTime() - I(e) - n
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class Ut extends u {
  priority = 40;
  parse(e) {
    return ce(e);
  }
  set(e, t, n) {
    return [p(e, n * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class St extends u {
  priority = 20;
  parse(e) {
    return ce(e);
  }
  set(e, t, n) {
    return [p(e, n), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const en = {
  G: new gt(),
  y: new pt(),
  Y: new xt(),
  R: new Pt(),
  u: new Dt(),
  Q: new Mt(),
  q: new kt(),
  M: new Tt(),
  L: new Ot(),
  w: new vt(),
  I: new Wt(),
  d: new Ht(),
  D: new Nt(),
  E: new It(),
  e: new Ft(),
  c: new Ct(),
  i: new Qt(),
  a: new Rt(),
  b: new Xt(),
  B: new Gt(),
  h: new Bt(),
  H: new At(),
  K: new jt(),
  k: new $t(),
  m: new Vt(),
  s: new zt(),
  S: new Jt(),
  X: new Zt(),
  x: new Kt(),
  t: new Ut(),
  T: new St()
}, tn = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, nn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, rn = /^'([^]*?)'?$/, an = /''/g, sn = /\S/, on = /[a-zA-Z]/;
function dn(r, e, t, n) {
  const a = () => p(t, NaN), s = lt(), o = s.locale ?? ne, c = s.firstWeekContainsDate ?? s.locale?.options?.firstWeekContainsDate ?? 1, P = s.weekStartsOn ?? s.locale?.options?.weekStartsOn ?? 0;
  if (!e)
    return r ? a() : g(t, n?.in);
  const x = {
    firstWeekContainsDate: c,
    weekStartsOn: P,
    locale: o
  }, m = [new bt(n?.in, t)], b = e.match(nn).map((i) => {
    const f = i[0];
    if (f in Q) {
      const D = Q[f];
      return D(i, o.formatLong);
    }
    return i;
  }).join("").match(tn), Y = [];
  for (let i of b) {
    ie(i) && R(i, e, r), oe(i) && R(i, e, r);
    const f = i[0], D = en[f];
    if (D) {
      const { incompatibleTokens: j } = D;
      if (Array.isArray(j)) {
        const $ = Y.find(
          (V) => j.includes(V.token) || V.token === f
        );
        if ($)
          throw new RangeError(
            `The format string mustn't contain \`${$.fullToken}\` and \`${i}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && Y.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${i}\` and any other token at the same time`
        );
      Y.push({ token: f, fullToken: i });
      const C = D.run(
        r,
        i,
        o.match,
        x
      );
      if (!C)
        return a();
      m.push(C.setter), r = C.rest;
    } else {
      if (f.match(on))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + f + "`"
        );
      if (i === "''" ? i = "'" : f === "'" && (i = un(i)), r.indexOf(i) === 0)
        r = r.slice(i.length);
      else
        return a();
    }
  }
  if (r.length > 0 && sn.test(r))
    return a();
  const fe = m.map((i) => i.priority).sort((i, f) => f - i).filter((i, f, D) => D.indexOf(i) === f).map(
    (i) => m.filter((f) => f.priority === i).sort((f, D) => D.subPriority - f.subPriority)
  ).map((i) => i[0]);
  let E = g(t, n?.in);
  if (isNaN(+E)) return a();
  const A = {};
  for (const i of fe) {
    if (!i.validate(E, x))
      return a();
    const f = i.set(E, A, x);
    Array.isArray(f) ? (E = f[0], Object.assign(A, f[1])) : E = f;
  }
  return E;
}
function un(r) {
  return r.match(rn)[1].replace(an, "'");
}
const ln = "-options-hidden", fn = "-selected-values-hidden";
export {
  ln as O,
  fn as S,
  ee as a,
  O as b,
  p as c,
  L as d,
  H as e,
  cn as f,
  q as g,
  N as h,
  Le as i,
  Ye as j,
  Pe as k,
  Ie as l,
  Ke as m,
  me as n,
  ne as o,
  dn as p,
  we as q,
  re as r,
  J as s,
  g as t,
  ae as u,
  be as v,
  _ as w,
  pe as x,
  ge as y
};
//# sourceMappingURL=select.shared.js.map
